import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
    container: {
        paddingHorizontal: 25,
    },
    contentTitlePage: {
        height: 60,
        backgroundColor: '#fff',
        width: '80%',
        alignSelf: 'center',
        borderTopLeftRadius: 20,
        borderBottomRightRadius: 20,
        borderWidth: 1,
        borderColor: "#196059",
        marginTop: -25,
        shadowColor: "#000",
        shadowOffset: {
            width: 0,
            height: 2,
        },
        shadowOpacity: 0.25,
        shadowRadius: 4.84,
        elevation: 5,
    },
    titlePage: {
        textAlign: 'center',
        marginTop: 18,
        fontWeight: 'bold',
        fontSize: 16
    }
});

export default styles;